import tw, { styled } from 'twin.macro';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Logo } from '@restworld/ui-ds-base';

const Wrapper = styled.div`
  ${tw`flex items-stretch min-h-screen`}
  background-color: #fafafa;
`;

const Content = styled.div`
  ${tw`flex flex-col items-center flex-1 gap-12 px-4 py-10`}
`;

const Title = styled.h1`
  ${tw`text-xl font-bold text-center text-black`}
  max-width: 320px;
  line-height: 1.21;
`;

const Card = styled.div`
  ${tw`flex flex-col items-center gap-8 w-full`}
  max-width: 480px;
  padding: 40px 20px 20px;
  border: 1px solid #dedee1;
  border-radius: 16px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 26, 0.1);
  background-color: #fafafa;
`;

const MessageGroup = styled.div`
  ${tw`flex flex-col w-full gap-2`}
`;

const Message = styled.p`
  ${tw`text-base font-medium text-center text-black`}
  line-height: 1.21;
`;

const ButtonGroup = styled.div`
  ${tw`flex flex-col items-center w-full gap-4`}
`;

interface InvalidReferralCodeProps {
  onGoBack: () => void;
  onProceedWithout: () => void;
}

export const InvalidReferralCode: React.FC<InvalidReferralCodeProps> = ({ onGoBack, onProceedWithout }) => {
  const { t } = useTranslation('restaurant-onboarding');

  return (
    <Wrapper>
      <Content>
        <Logo variant="horizontal" title="Restworld" className="h-8 w-auto text-purple-700" />
        <Title>{t('invalid_referral_link_title')}</Title>
        <Card>
          <MessageGroup>
            <Message>{t('invalid_referral_link_message')}</Message>
            <Message>{t('invalid_referral_link_try_again')}</Message>
          </MessageGroup>
          <ButtonGroup>
            <Button variant="primary" tw="w-full" onClick={onProceedWithout}>
              {t('invalid_referral_link_proceed_without')}
            </Button>
            <Button variant="tertiary" tw="w-full" onClick={onGoBack}>
              {t('invalid_referral_link_ask_another')}
            </Button>
          </ButtonGroup>
        </Card>
      </Content>
    </Wrapper>
  );
};
